import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DialogCloseButton from "@profilog/commons/components/DialogCloseButton";

export default function RejectCooperationDialog({ trigger, onConfirmClick }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState();

    return (
        <Fragment>
            {trigger && trigger(() => setOpen(true))}
            <Dialog open={open} onClose={handleClose}>
                <DialogCloseButton onClick={handleClose} />
                <DialogTitle>
                    {t("communications.CooperationRequests.RejectCooperation.CooperationRejection")}
                </DialogTitle>

                <DialogContent>
                    <p>{t("communications.CooperationRequests.RejectCooperation.ReallyRejectCooperation")}</p>
                </DialogContent>

                <DialogActions>
                    <Button variant="contained" color="error" onClick={() => handleConfirm()} tw="normal-case">
                        {t("communications.CooperationRequests.RejectCooperation.YesReallyRejectCooperation")}
                    </Button>

                    <Button variant="contained" color="success" onClick={handleClose} tw="normal-case">
                        {t("communications.CooperationRequests.RejectCooperation.NoDoNotRejectCooperation")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );

    function handleConfirm() {
        onConfirmClick();
        handleClose();
    }

    function handleClose() {
        setOpen(false);
    }
}
